import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import { BookOpen, CheckCircle, Loader2, XCircle } from 'lucide-react';
import axios from 'axios';

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token') || '';
  const [state, setState] = useState('loading');

  useEffect(() => {
    if (!token) { setState('error'); return; }
    axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/api/auth/verify-email`,
      { token }
    ).then(() => {
      setState('success');
      setTimeout(() => navigate('/dashboard'), 3000);
    }).catch(() => setState('error'));
  }, [token, navigate]);

  return (
    <div className="min-h-screen bg-[#FDFBF7] flex items-center justify-center p-6 paper-texture">
      <div className="w-full max-w-md text-center">
        <div className="inline-flex items-center gap-2 mb-8">
          <BookOpen className="w-8 h-8 text-[#6B7A4F]" />
          <span className="text-2xl font-bold text-[#2D2A26]">Bookish Bestie</span>
        </div>
        <div className="glass-card p-10 rounded-2xl">
          {state === 'loading' && (
            <>
              <Loader2 className="w-16 h-16 text-[#6B7A4F] animate-spin mx-auto mb-4" />
              <h2 className="text-2xl font-semibold text-[#2D2A26]">Verifying your email...</h2>
            </>
          )}
          {state === 'success' && (
            <>
              <CheckCircle className="w-16 h-16 text-[#8E9E82] mx-auto mb-4" />
              <h2 className="text-2xl font-semibold text-[#2D2A26] mb-2">Email Verified!</h2>
              <p className="text-[#5C5955]">Redirecting to your dashboard...</p>
            </>
          )}
          {state === 'error' && (
            <>
              <XCircle className="w-16 h-16 text-red-400 mx-auto mb-4" />
              <h2 className="text-2xl font-semibold text-[#2D2A26] mb-2">Verification Failed</h2>
              <p className="text-[#5C5955] mb-4">This link may have expired or already been used.</p>
              <Link to="/dashboard" className="text-[#6B7A4F] font-semibold hover:underline">Go to Dashboard</Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;
